import type { WebhookDestinationRoom } from "./types";
import { isPostableRoomRole } from "./validation";

export function selectWebhookDestinationRooms(rooms: unknown): WebhookDestinationRoom[] {
  if (!Array.isArray(rooms)) return [];
  const out: WebhookDestinationRoom[] = [];
  for (const raw of rooms) {
    if (!raw || typeof raw !== "object") continue;
    const room = raw as Record<string, unknown>;
    if (typeof room.id !== "string" || !room.id) continue;
    if (room.kind !== "public" && room.kind !== "private") continue;
    if (typeof room.archived_at === "number" && room.archived_at > 0) continue;
    const role = typeof room.my_role === "string" ? room.my_role : null;
    if (!isPostableRoomRole(role)) continue;
    const name = typeof room.name === "string" && room.name.trim() ? room.name : room.id;
    out.push({ id: room.id, name, kind: room.kind });
  }
  return out;
}
